import React, { useEffect, useState } from "react";
import { SingleCardMetric } from "../ui/SingleCardMetric";

interface ShelterOccupiedMetricState {
  data: any;
}

export const ShelterOccupiedMetric = ({ data }: ShelterOccupiedMetricState) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [occupied, setOccupied] = useState<string>();

  useEffect(() => {
    if (data) {
      const { occupancy } = data;
      const empty = occupancy?.filter((item: any) => item.occupant_id !== null).length;
      setOccupied(empty?.toString());
    }
    setIsLoading(false);
  }, [data]);

  return <SingleCardMetric title={"Occupied Beds"} total={occupied} isLoading={isLoading} />;
};
